import React from "react";
import { Typography, Upload } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { useCreateFileInStorageMutation } from "../../store/api/formbricks/survey";
import { useFormContext } from "react-hook-form";

const FileInput = ({ label, ...props }, ref) => {
    const { setValue } = useFormContext();

    const filesList = props.value
        ? [
              {
                  uid: "-1",
                  name: "image.png",
                  status: "done",
                  url: props.value,
              },
          ]
        : undefined;

    const [uploadFile, { isLoading: isUploading }] =
        useCreateFileInStorageMutation();

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.onload = function (e) {
            const arrayBuffer = e.target.result;
            const uint8Array = new Uint8Array(arrayBuffer);

            callback(uint8Array);
        };
        reader.readAsArrayBuffer(img);
    };

    const handleFileInputChange = async (options) => {
        const { file, onSuccess } = options;
        getBase64(file, async (url) => {
            const res = await uploadFile({
                fileBuffer: Array.from(new Uint8Array(url)),
                fileName: file.name,
                environmentId: "clt5v3igx0009p93zkk3fnvhl",
                allowedFileExtensions: "png,jpg",
            });
            onSuccess(res.data.url, file);
            setValue(props.name, res.data.url, { shouldValidate: true });
        });
    };

    const uploadButton = (
        <button style={{ border: 0, background: "none" }} type="button">
            {isUploading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload</div>
        </button>
    );

    return (
        <div>
            {label && <Typography.Title level={5}>{label}</Typography.Title>}
            <Upload
                ref={ref}
                listType="picture-card"
                customRequest={handleFileInputChange}
                maxCount={1}
                showUploadList={true}
                accept="image/png, image/jpeg"
                fileList={filesList}
                onRemove={() =>
                    setValue(props.name, "", { shouldValidate: true })
                }
            >
                {!props.value && !isUploading && uploadButton}
            </Upload>
        </div>
    );
};

export default React.forwardRef(FileInput);
